import { type Eventtype } from "@entities/event";
import { type Event } from "@entities/event";

const getDaysAgo = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date.toISOString();
};

const getDaysFromNow = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString();
};

// Helper für heute mit bestimmter Uhrzeit
const getTodayAt = (hours: number, minutes: number = 0): string => {
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
};

export const demoEvents: Event[] = [
  // Störungen
  {
    id: "ev-1",
    tenant_id: "1",
    eventtype_id: "evt-1",
    title: "Backofen Heizung ausgefallen",
    description:
      "Oberhitze im Etagenofen funktioniert nicht mehr. Backofen musste außer Betrieb genommen werden.",
    start_date: `${getDaysAgo(2).split("T")[0]}T14:30:00Z`,
    end_date: `${getDaysAgo(2).split("T")[0]}T18:15:00Z`,
    all_day: false,
    contactId: "per-14",
    branch_id: "branch-1",
    created_by: "per-6",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-2",
    tenant_id: "1",
    eventtype_id: "evt-1",
    title: "Kühltheke Kompressor defekt",
    description: "Kompressor macht laute Geräusche, Kühlleistung reduziert. Service angefordert.",
    start_date: `${getDaysAgo(5).split("T")[0]}T09:00:00Z`,
    end_date: `${getDaysAgo(5).split("T")[0]}T12:30:00Z`,
    all_day: false,
    contactId: "per-15",
    branch_id: "branch-2",
    created_by: "per-8",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-3",
    tenant_id: "1",
    eventtype_id: "evt-1",
    title: "Kassendrucker defekt",
    description: "Bondrucker druckt nicht mehr. Ersatzgerät eingesetzt.",
    start_date: `${getDaysAgo(1).split("T")[0]}T16:45:00Z`,
    end_date: `${getDaysAgo(1).split("T")[0]}T17:30:00Z`,
    all_day: false,
    branch_id: "branch-4",
    created_by: "per-10",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Inspektionen
  {
    id: "ev-4",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Jahresinspektion Konvektomat",
    description: "Jährliche Wartung und Inspektion durch Rational Service.",
    start_date: `${getDaysFromNow(14).split("T")[0]}T08:00:00Z`,
    end_date: `${getDaysFromNow(14).split("T")[0]}T12:00:00Z`,
    all_day: false,
    contactId: "per-18",
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-5",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Hygiene-Kontrolle Backstube",
    description: "Routinemäßige Hygiene-Kontrolle durch Gesundheitsamt.",
    start_date: `${getDaysFromNow(7).split("T")[0]}T10:00:00Z`,
    end_date: `${getDaysFromNow(7).split("T")[0]}T12:00:00Z`,
    all_day: false,
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Reparaturen
  {
    id: "ev-6",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Heizelement ausgetauscht",
    description:
      "Defektes Heizelement im Etagenofen durch Techniker ersetzt. Backofen wieder voll funktionsfähig.",
    start_date: `${getDaysAgo(1).split("T")[0]}T08:00:00Z`,
    end_date: `${getDaysAgo(1).split("T")[0]}T11:30:00Z`,
    all_day: false,
    contactId: "per-14",
    branch_id: "branch-1",
    created_by: "per-6",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-7",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Spülmaschine Pumpe repariert",
    description: "Ablaufpumpe gereinigt und repariert. Gerät läuft wieder normal.",
    start_date: `${getDaysAgo(8).split("T")[0]}T14:00:00Z`,
    end_date: `${getDaysAgo(8).split("T")[0]}T16:00:00Z`,
    all_day: false,
    contactId: "per-17",
    branch_id: "branch-2",
    created_by: "per-7",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Wartungen
  {
    id: "ev-8",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Filterreinigung Dunstabzug",
    description: "Monatliche Reinigung der Fettfilter in der Dunstabzugshaube.",
    start_date: `${getDaysAgo(3).split("T")[0]}T06:00:00Z`,
    end_date: `${getDaysAgo(3).split("T")[0]}T07:30:00Z`,
    all_day: false,
    contactId: "per-6",
    branch_id: "branch-1",
    created_by: "per-6",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-9",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Entkalkung Kaffeemaschine",
    description: "Routinemäßige Entkalkung der Kaffeemaschine durchgeführt.",
    start_date: `${getDaysAgo(4).split("T")[0]}T07:00:00Z`,
    end_date: `${getDaysAgo(4).split("T")[0]}T08:00:00Z`,
    all_day: false,
    contactId: "per-11",
    branch_id: "branch-2",
    created_by: "per-8",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-10",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Dampferzeuger entkalkt",
    description: "Entkalkung des Dampferzeugers im Konvektomat.",
    start_date: `${getDaysAgo(10).split("T")[0]}T14:00:00Z`,
    end_date: `${getDaysAgo(10).split("T")[0]}T16:00:00Z`,
    all_day: false,
    contactId: "per-18",
    branch_id: "branch-1",
    created_by: "per-2",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Inbetriebnahmen
  {
    id: "ev-11",
    tenant_id: "1",
    eventtype_id: "evt-5",
    title: "Neue Teigknetmaschine installiert",
    description: "Neue Spiralteigknetmaschine in der Backstube installiert und eingewiesen.",
    start_date: getDaysAgo(30),
    all_day: true,
    branch_id: "branch-1",
    created_by: "per-2",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-12",
    tenant_id: "1",
    eventtype_id: "evt-5",
    title: "Neuer Gärschrank in Betrieb",
    description: "Gärschrank aufgestellt und Temperaturprogramme eingestellt.",
    start_date: getDaysAgo(45),
    all_day: true,
    branch_id: "branch-1",
    created_by: "per-2",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Schulungen
  {
    id: "ev-13",
    tenant_id: "1",
    eventtype_id: "evt-9",
    title: "Einweisung neuer Konvektomat",
    description: "Schulung für alle Mitarbeiter zur Bedienung des neuen Rational-Geräts.",
    start_date: getDaysAgo(25),
    all_day: true,
    contactId: "per-18",
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-14",
    tenant_id: "1",
    eventtype_id: "evt-9",
    title: "Hygiene-Schulung Backstube",
    description: "Jährliche Hygiene-Schulung für alle Backstuben-Mitarbeiter.",
    start_date: `${getDaysFromNow(21).split("T")[0]}T09:00:00Z`,
    end_date: `${getDaysFromNow(21).split("T")[0]}T16:00:00Z`,
    all_day: false,
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Standortwechsel
  {
    id: "ev-15",
    tenant_id: "1",
    eventtype_id: "evt-7",
    title: "Tiefkühltruhe umgezogen",
    description: "Tiefkühltruhe von Filiale Marktplatz zur Filiale Heidelberg verlegt.",
    start_date: getDaysAgo(60),
    all_day: true,
    contactId: "per-7",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Software-Updates
  {
    id: "ev-16",
    tenant_id: "1",
    eventtype_id: "evt-8",
    title: "Kassensoftware Update",
    description: "Update auf neue Version der Vectron-Kassensoftware mit neuen Funktionen.",
    start_date: `${getDaysAgo(15).split("T")[0]}T20:00:00Z`,
    end_date: `${getDaysAgo(15).split("T")[0]}T22:00:00Z`,
    all_day: false,
    contactId: "per-16",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // Mehrtägige Events
  {
    id: "ev-multi-1",
    tenant_id: "1",
    eventtype_id: "evt-9",
    title: "Backkunst-Seminar",
    description: "3-tägiges Seminar zu neuen Backtechniken und Trends.",
    start_date: `${getDaysFromNow(7).split("T")[0]}T00:00:00Z`,
    end_date: `${getDaysFromNow(9).split("T")[0]}T23:59:59Z`,
    all_day: true,
    contactId: "per-2",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-multi-2",
    tenant_id: "1",
    eventtype_id: "evt-10",
    title: "iba Messe München",
    description: "Fachmesse für Bäckerei und Konditorei. Besuch verschiedener Aussteller.",
    start_date: `${getDaysFromNow(45).split("T")[0]}T00:00:00Z`,
    end_date: `${getDaysFromNow(48).split("T")[0]}T23:59:59Z`,
    all_day: true,
    contactId: "per-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-multi-3",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Große Jahreswartung Backstube",
    description: "Umfassende Wartung aller Produktionsgeräte in der Backstube.",
    start_date: `${getDaysFromNow(60).split("T")[0]}T00:00:00Z`,
    end_date: `${getDaysFromNow(62).split("T")[0]}T23:59:59Z`,
    all_day: true,
    contactId: "per-6",
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-multi-4",
    tenant_id: "1",
    eventtype_id: "evt-11",
    title: "Urlaub - Backstubenleitung",
    description: "Urlaubsabwesenheit Klaus Brenner. Vertretung: Petra Weiß",
    start_date: `${getDaysFromNow(14).split("T")[0]}T00:00:00Z`,
    end_date: `${getDaysFromNow(28).split("T")[0]}T23:59:59Z`,
    all_day: true,
    contactId: "per-2",
    created_by: "per-2",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // ===== NEUE EVENTS FÜR HEUTE UND DIESE WOCHE =====

  // HEUTE - Verschiedene Standorte
  {
    id: "ev-today-1",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Kühltheke Wartung",
    description: "Planmäßige Wartung der Kühltheke inkl. Kondensatorreinigung.",
    start_date: getTodayAt(9, 0),
    end_date: getTodayAt(11, 0),
    all_day: false,
    contactId: "per-15",
    branch_id: "branch-2", // Marktplatz
    created_by: "per-8",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-today-2",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Hygiene-Check Filialen",
    description: "Routinemäßiger Hygiene-Check in den Verkaufsfilialen.",
    start_date: getTodayAt(14, 0),
    end_date: getTodayAt(15, 30),
    all_day: false,
    contactId: "per-7",
    branch_id: "branch-3", // Neckarstadt
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-today-3",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Bondrucker reparieren",
    description: "Defekten Bondrucker austauschen und neues Gerät einrichten.",
    start_date: getTodayAt(10, 0),
    end_date: getTodayAt(12, 0),
    all_day: false,
    contactId: "per-16",
    branch_id: "branch-4", // Ludwigshafen
    created_by: "per-10",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-today-4",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Backofen Dichtung erneuern",
    description: "Türdichtung am Etagenofen austauschen.",
    start_date: getTodayAt(7, 0),
    end_date: getTodayAt(10, 0),
    all_day: false,
    contactId: "per-14",
    branch_id: "branch-1", // Backstube
    created_by: "per-6",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // MORGEN
  {
    id: "ev-tomorrow-1",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Kaffeemaschine Entkalkung",
    description: "Entkalkung und Reinigung der Kaffeemaschine.",
    start_date: `${getDaysFromNow(1).split("T")[0]}T08:00:00Z`,
    end_date: `${getDaysFromNow(1).split("T")[0]}T09:30:00Z`,
    all_day: false,
    contactId: "per-7",
    branch_id: "branch-5", // Heidelberg
    created_by: "per-11",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-tomorrow-2",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Kälteinspektion Kühlgeräte",
    description: "Temperaturmessung und Protokollierung aller Kühlgeräte.",
    start_date: `${getDaysFromNow(1).split("T")[0]}T10:00:00Z`,
    end_date: `${getDaysFromNow(1).split("T")[0]}T12:00:00Z`,
    all_day: false,
    contactId: "per-15",
    branch_id: "branch-6", // Weinheim
    created_by: "per-12",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // ÜBERMORGEN
  {
    id: "ev-day-after-1",
    tenant_id: "1",
    eventtype_id: "evt-8", // Software-Update
    title: "Kassensystem Update",
    description: "Software-Update für das Kassensystem mit neuen Funktionen.",
    start_date: `${getDaysFromNow(2).split("T")[0]}T09:00:00Z`,
    end_date: `${getDaysFromNow(2).split("T")[0]}T10:30:00Z`,
    all_day: false,
    contactId: "per-16",
    branch_id: "branch-7", // Schwetzingen
    created_by: "per-13",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  // DIESE WOCHE
  {
    id: "ev-week-1",
    tenant_id: "1",
    eventtype_id: "evt-9", // Schulung
    title: "Neue Mitarbeiter Einweisung",
    description: "Einweisung neuer Verkaufsmitarbeiter in Kassenbedienung und Hygienestandards.",
    start_date: `${getDaysFromNow(3).split("T")[0]}T14:00:00Z`,
    end_date: `${getDaysFromNow(3).split("T")[0]}T17:00:00Z`,
    all_day: false,
    contactId: "per-8",
    branch_id: "branch-3", // Neckarstadt
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-week-2",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Großwartung Kältetechnik",
    description: "Umfassende Wartung aller Kühlgeräte in der Filiale.",
    start_date: `${getDaysFromNow(4).split("T")[0]}T08:00:00Z`,
    end_date: `${getDaysFromNow(4).split("T")[0]}T14:00:00Z`,
    all_day: false,
    contactId: "per-15",
    branch_id: "branch-4", // Ludwigshafen
    created_by: "per-10",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-week-3",
    tenant_id: "1",
    eventtype_id: "evt-3", // Reparatur
    title: "Sicherheitsinspektion Elektrogeräte",
    description: "Jährliche Sicherheitsinspektion aller elektrischen Geräte.",
    start_date: `${getDaysFromNow(5).split("T")[0]}T09:00:00Z`,
    end_date: `${getDaysFromNow(5).split("T")[0]}T16:00:00Z`,
    all_day: false,
    contactId: "per-6",
    branch_id: "branch-2", // Marktplatz
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },

  {
    id: "ev-recur-1",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Wöchentliche Filterreinigung",
    description: "Wiederkehrende wöchentliche Reinigung der Filter.",
    start_date: `${getDaysFromNow(1).split("T")[0]}T08:00:00Z`,
    end_date: `${getDaysFromNow(1).split("T")[0]}T09:00:00Z`,
    all_day: false,
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    recurrence: {
      rule: { frequency: "weekly", interval: 1, weekdays: [1, 3, 5] },
      end: { type: "endDate", endDate: getDaysFromNow(90).split("T")[0] },
    },
    recurrenceSeriesId: "series-weekly-1",
    recurrenceOccurrenceIndex: 0,
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
  },
  {
    id: "ev-recur-2",
    tenant_id: "1",
    eventtype_id: "evt-3",
    title: "Wöchentliche Filterreinigung",
    description: "Wiederkehrende wöchentliche Reinigung der Filter.",
    start_date: `${getDaysFromNow(8).split("T")[0]}T08:00:00Z`,
    end_date: `${getDaysFromNow(8).split("T")[0]}T09:00:00Z`,
    all_day: false,
    done: false,
    doneDate: null,
    doneUserId: null,
    ownerUserId: "per-1",
    branch_id: "branch-1",
    created_by: "per-1",
    createdAt: new Date().toISOString(),
    recurrence: {
      rule: { frequency: "weekly", interval: 1, weekdays: [1, 3, 5] },
      end: { type: "endDate", endDate: getDaysFromNow(90).split("T")[0] },
    },
    recurrenceSeriesId: "series-weekly-1",
    recurrenceOccurrenceIndex: 1,
  },
];

export const demoEventtypes: Eventtype[] = [
  {
    id: "evt-1",
    tenant_id: "1",
    name: "Störung",
    color: "#ef4444",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-3",
    tenant_id: "1",
    name: "Reparatur",
    color: "#f97316",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-5",
    tenant_id: "1",
    name: "Inbetriebnahme",
    color: "#10b981",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-6",
    tenant_id: "1",
    name: "Außerbetriebnahme",
    color: "#64748b",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-7",
    tenant_id: "1",
    name: "Standortwechsel",
    color: "#06b6d4",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-8",
    tenant_id: "1",
    name: "Software-Update",
    color: "#8b5cf6",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-9",
    tenant_id: "1",
    name: "Schulung",
    color: "#f59e0b",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-10",
    tenant_id: "1",
    name: "Messe",
    color: "#ec4899",
    createdAt: new Date().toISOString(),
  },
  {
    id: "evt-11",
    tenant_id: "1",
    name: "Urlaub/Abwesenheit",
    color: "#a855f7",
    createdAt: new Date().toISOString(),
  },
];
